(function ($) {
  Drupal.behaviors.r4_info_mob = {
    attach: function (context, settings) {
      $('#r4_mpp_labels_mob', context).once('r4_info_mob', function () {
        // Add ID to the mpp we are targeting
        var mppContext = $('#r4_mpp_labels_mob').parent().prev('.mpp');

        mppContext.attr('id', 'r4_mpp_labels_mob_mpp');
        mppContext.wrap("<div class='el_boutique_wrapper'></div>");

        // Wait until all 5 products are in place
        var checkExist = setInterval(function () {
          if ($('#r4_mpp_labels_mob_mpp .mpp__product-grid li.product-brief').length === 5) {
            clearInterval(checkExist);
            mppContext.find('.mpp__product-grid .product-brief:eq( 0 )').before("<h2 class='el_boutique_h2'>" + $('#r4_mpp_labels_h2_1').html() + '</h2>');
            mppContext.find('.mpp__product-grid .product-brief:eq( 0 )').before("<h2 class='el_boutique_h2'>" + $('#r4_mpp_labels_h2_2').html() + '</h2>');
            mppContext.find('.mpp__product-grid .product-brief:eq( 2 )').before("<h2 class='el_boutique_h2 mpp_labels_full_row'>" + $('#r4_mpp_labels_h2_3').html() + '</h2>');
            mppContext.find('.mpp__product-grid .product-brief:eq( 4 )').before("<h2 class='el_boutique_h2 mpp_labels_full_row'>" + $('#r4_mpp_labels_h2_4').html() + '</h2>');
            var headersMove = $('#r4_mod5, #r4_mpp_labels_body_1').detach();

            $('#r4_mpp_labels_mob_mpp').prepend(headersMove);
          }
        }, 10);
      });
    }
  };
})(jQuery);
